import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Partner from "@classes/Partner";
import Session from "@classes/Session";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class Header extends React.PureComponent {
    static propTypes = {
        partner: PropTypes.instanceOf(Partner),
        session: PropTypes.instanceOf(Session),
    };

    render() {
        const {props} = this;
        const {partner} = props;
        const classes = createClassName("Header", {});

        return (
            <header className={classes}>
                <div className="Header-wrapper">
                    <div className="Header-column center">
                        {partner && <HeaderLogo link={"/" + partner.name} imageUrl={partner.logoUrl} clickable={partner.isLogoClickable}/>}
                    </div>
                </div>
            </header>
        );
    }
}

// PRIVATE COMPONENTS
function HeaderLogo({link, imageUrl, clickable}) {
    return (
        <React.Fragment>
            {
                clickable ?
                <a className="Header-logo" href={link}>
                    <img className="Header-logo-img" src={imageUrl} alt=""/>
                </a>
                :
                <a className="Header-logo" href={link} onClick={(e) => e.preventDefault()}>
                    <img className="Header-logo-img" src={imageUrl} alt=""/>
                </a>
            }
        </React.Fragment>

    );
}


// WEBPACK FOOTER //
// ./src/components/Header/Header.js